module.exports = __webpack_public_path__ + "static/media/user.7329de3d.svg";